export default "__VITE_ASSET__CQ9J_1xk__"